import { DISALLOWED_BROWSERS } from "@/helpers/constants";

export default {
  name: "CheckBrowserMixin",
  data() {
    return {
      userAgent: window.navigator.userAgent.toUpperCase()
    };
  },
  computed: {
    /**
     * Is browser not allowable flag
     * @return {boolean}
     */
    isNotAllowableBrowser() {
      return Object.keys(DISALLOWED_BROWSERS).some(key => {
        return this.userAgent.includes(key);
      });
    },

    /**
     * Not allowable browser name
     * @return {String}
     */
    browserName() {
      let browser = Object.keys(DISALLOWED_BROWSERS).find(key => {
        return this.userAgent.includes(key);
      });

      return browser ? DISALLOWED_BROWSERS[browser] : "";
    }
  }
};
